import { Component, OnInit, Output, EventEmitter,ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SetSelectedAlgorithm, UpdateStepValidity, GetAlgorithmList, SetAlgoLoading, GetTimeseries} from 'src/app/core/store/predictive-failure-configuration/predictive-failure-configuration.action';
import { AlgorithmList } from 'src/app/core/models/insight-configuration.model';
import { Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PREDICTIVE_CREATE_COMPONENTS } from 'src/app/core/enums/predictiveFailure.enum';
import { CONFIG_MODE } from 'src/app/core/enums/insightConfigurations.enum';

@Component({
  selector: 'app-predictive-algorithm',
  templateUrl: './predictive-algorithm.component.html',
  styleUrls: ['./predictive-algorithm.component.scss']
})
export class PredictiveAlgorithmComponent implements OnInit {
  @Output() algorithmLoaded: EventEmitter<any> = new EventEmitter<any>();
  
  public selectedAlgorithm: any;
  public unsubscribe = new Subject<void>();
  public algorithmList: AlgorithmList[];
  public selectedValue = null;
  public algorithmForm: UntypedFormGroup;
  public mode = CONFIG_MODE.CREATE;
  constructor(
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.mode = this.store.selectSnapshot(state => state.configurations.predictiveFailure.mode);
    this.initForm();
    this.store.dispatch(new GetTimeseries());
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public initForm() {
    this.selectedAlgorithm = this.store.selectSnapshot(state => state.configurations.predictiveFailure.selectedAlgorithm);
    this.algorithmForm = new UntypedFormGroup({
      algorithm: new UntypedFormControl({value: this.selectedAlgorithm ? this.selectedAlgorithm : null, disabled: this.mode === CONFIG_MODE.EDIT}, [Validators.required]),
    })
    this.listenToFormChanges();
    this.getAlgorithmList();
    if(this.mode === CONFIG_MODE.EDIT) {
      this.store.dispatch(new UpdateStepValidity(PREDICTIVE_CREATE_COMPONENTS.ALGORITHM, true))
    } 
  }

  public listenToFormChanges() {
    
    this.algorithmForm.statusChanges.pipe(takeUntil(this.unsubscribe)).subscribe((value) => {
      if(value === 'VALID') {
        this.store.dispatch(new UpdateStepValidity(PREDICTIVE_CREATE_COMPONENTS.ALGORITHM, true))
      } else {
        this.store.dispatch(new UpdateStepValidity(PREDICTIVE_CREATE_COMPONENTS.ALGORITHM, false))
      }
    })

    this.algorithmForm.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      const value = this.algorithmForm.getRawValue();
      this.store.dispatch(new SetSelectedAlgorithm(value?.algorithm))
      
    })
    this.changeDetectorRef.detectChanges();
  }

  public setSelectedAlgorithm(algorithm: any) {
    if(this.algorithmForm) {
      this.algorithmForm?.controls.algorithm.setValue(algorithm);
      this.algorithmForm.controls.algorithm.updateValueAndValidity();
    }
  }

  public getAlgorithmList() {
    this.store.dispatch(new SetAlgoLoading(true));
    this.algorithmList = this.store.selectSnapshot(state => state.configurations.predictiveFailure.algorithmList);
    let configId = '';
    if(this.mode === CONFIG_MODE.EDIT){
      configId = this.store.selectSnapshot(state => state.configurations.predictiveFailure.configurationDetailsSaved?.categoryId);
    }else{
      configId = this.store.selectSnapshot(state => state.configurations.selectedConfigType?.viewId);
    }

    if(this.algorithmList.length === 0) {
      return this.store.dispatch(new GetAlgorithmList(configId)).pipe()
      .subscribe(state => {
          this.algorithmList = state.configurations.predictiveFailure.algorithmList;
          this.setSelectedAlgorithm(this.algorithmList[0]);
          this.store.dispatch(new SetAlgoLoading(false));
        }
      )
    } else {
      this.setSelectedAlgorithm(this.algorithmList[0]);
      this.store.dispatch(new SetAlgoLoading(false))
    }
  }

  get CONFIG_MODE() {
    return CONFIG_MODE;
  }
}
